import React from 'react'
import { Button, Divider, Steps } from 'antd'
import { SolutionOutlined, SettingOutlined, SmileOutlined } from '@ant-design/icons'
import { FormComponent } from '../../../BaseComponent'
import IIntegrationSettings from '../../../../interfaces/IIntegrationSettings'
import { ConnectRequest, PartnerAuthRequest, RetrieveTotalPetRequest, UpdateSettingsRequest, VerifySettingsRequest } from '../../../../services/integration/interfaces/ApiRequest'
import { SpecieConsumer } from '../../../../context/SpecieContext'
import { ShelterProvider, ShelterConsumer } from '../../../../context/ShelterContext'

// Forms
import Auth from '../Auth'
import Settings from '../Settings'
import Connect from '../Connect'
import IIntegration from '../../../../interfaces/IIntegration'

export type RegisterIntegrationProps = {
  authUuid?: string | null,
  integration?: IIntegration | null
  settings: IIntegrationSettings | null,
  total: number,
  error: any | null

  loading: boolean,
  history: any,

  verifySettings: (args: VerifySettingsRequest) => Promise<any>,
  updateSettings: (args: UpdateSettingsRequest) => Promise<any>,

  retrieveTotalPet: (args: RetrieveTotalPetRequest) => Promise<any>,

  authPartner: (args: PartnerAuthRequest) => Promise<any>,

  makeConnection: (args: ConnectRequest) => Promise<any>
}

export default class RegisterIntegration extends FormComponent<RegisterIntegrationProps> {

  state = {
    finish: false
  }

  private settingsRef: any

  private toggleFinish = () => this.setState({ finish: true })

  private getCurrentStep = () => {
    const { authUuid } = this.props
    const { finish } = this.state

    if (!authUuid) return 0
    if (!finish) return 1

    return 2
  }

  private getStepStatus = (step: number) => {
    const { error } = this.props
    const currentStep = this.getCurrentStep()

    if (currentStep > step) return 'finish'
    
    if (error) return 'error'

    return 'wait'
  }

  render() {
    const {
      loading,
      history,
      error,
      authUuid,
      integration,
      settings,
      total,
      authPartner,
      verifySettings,
      retrieveTotalPet,
      updateSettings,
      makeConnection
    } = this.props

    const currentStep = this.getCurrentStep()

    return (
      <ShelterProvider>
        <ShelterConsumer>
          {({ fetching: fetchingShelter, shelters, requestShelterList }) => (
            <SpecieConsumer>
              {({ species, requestSpecieList }) => (
                <>
                  <Steps>
                    <Steps.Step status={this.getStepStatus(0)} title="Authentication" icon={<SolutionOutlined />} />
                    <Steps.Step status={this.getStepStatus(1)} title="Settings" icon={<SettingOutlined />} />
                    <Steps.Step status={this.getStepStatus(2)} title="Connect" icon={<SmileOutlined />} />
                  </Steps>

                  <div
                    style={{
                      display: currentStep === 0 ? 'unset' : 'none',
                      width: '100%'
                    }}
                  >
                    <Auth
                      authUuid={authUuid}
                      error={error}

                      shelters={shelters}

                      loading={loading}
                      contentLoading={fetchingShelter}
                      history={history}

                      loadShelters={requestShelterList}
                      authPartner={authPartner}
                    />
                  </div>

                  {
                    authUuid ? (
                      <div
                        style={{
                          display: currentStep === 1 ? 'unset' : 'none',
                          width: '100%',
                          marginTop: 30
                        }}
                      >
                        <Settings
                          ref={(refs) => this.settingsRef = refs}

                          integrationUuid={authUuid}
                          integration={integration}
                          settings={settings}
                          total={total}

                          species={species}

                          loading={loading}
                          contentLoading={fetchingShelter}
                          history={history}
                          error={error}
                          
                          loadSpecies={requestSpecieList}
                          
                          verifySettings={verifySettings}
                          updateSettings={updateSettings}

                          retrieveTotalPet={retrieveTotalPet}

                          onSaved={() => {
                            setTimeout(() => {
                              this.forceUpdate()
                            }, 1000)
                          }}
                        />

                        <Divider />

                        <Button type="primary" size="middle" disabled={!this.settingsRef?.hasSaved()} onClick={this.toggleFinish} block>
                          Continue
                        </Button>
                      </div>
                    ) : null
                  }

                  {
                    authUuid && currentStep === 2 ? (
                      <div
                        style={{
                          width: '100%',
                          marginTop: 30
                        }}
                      >
                        <Connect
                          integrationUuid={authUuid}

                          loading={loading}
                          error={error}
                          history={history}
                          
                          makeConnection={makeConnection}
                        />
                      </div>
                    ) : null
                  }
                </>
              )}
            </SpecieConsumer>
          )}
        </ShelterConsumer>
      </ShelterProvider>
    )
  }
}
